<template>
  <div >
    <!--    color: #FFFFFF;-->
    <div class="topbar">
      <img src="./images/tableBanner.png" alt class="BackgroundPic"/>
      <div style="position: absolute;color: white;font-family: Microsoft YaHei, Microsoft YaHei;margin-bottom: 250px" class="tableTitle">
        <!--            class="tableTitle"-->
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 14px;color: white">
          <el-breadcrumb-item :to="{ path: '/' }"><sapn style="color: white">首页</sapn></el-breadcrumb-item>
          <el-breadcrumb-item><sapn style="color: white">{{title}}</sapn></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <p class="tableTitle">{{title}}</p>

    </div>
    <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick" style="min-height: 800px;;margin-left: 230px;">
      <el-tab-pane
          v-for="item in data1"
          :key="item.itemName"
          :label="item.itemName"
          :name="item.itemName"
      >
        <div style="margin-left: 20px;">
          <div style="margin-top: 8px;">
            <span style="font-size: 20px;font-weight: bold;">{{item.itemName}}</span>
          </div>

          <div  v-for="(item,index) in resultData.listxts" :key="index" style="width: 1100px;">
            <div :id="item.id" style="border-top: 1px solid #E1E1E1;height: 130px;display:flex;">
              <div class="buttonSet">
                  <div style="font-size: 22px;margin-top:8px;">{{item.post.spec.publishTime.slice(5,10)}}</div>
                  <div style="font-size: 18px;">{{item.post.spec.publishTime.slice(0,4)}}</div>
              </div>
              <div  style="margin-left: 25px;width: 1000px;" >
             
                <div style="font-size: 18px;color: #19ad5e;font-weight: bold;margin-top: 20px">{{item.post.spec.title}}</div>
                <div style="margin-top:8px;font-size: 13px;color:#737777;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.post.status.excerpt}}</div>
                <el-link style="margin-top: 10px;color: #0069ff" @click="wordDetail(index,item.post.metadata.name,item.post.spec.title,item.post.spec.publishTime)">查看详情</el-link>
              </div>
            </div>
          </div>
         
          <div style="border-top: 1px solid #E1E1E1;width: 1100px;text-align: center">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.pageNum"
                background
                :page-sizes="[2,5,10]"
                :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
          </div>


        </div>
      </el-tab-pane>
    
    </el-tabs>
  </div>
</template>
<script>
import data from '@/assets/test.json';
import axios from "axios";
import * as Setting from "@/setting";
import {getHalo} from "@/setting";
const config = {
  headers: {
    Authorization: "Bearer pat_eyJraWQiOiJiOFJTWW90SWdrSERaWTZUWEt4X3NVbjcxRy1XRXp2THQ1UkJsTGVrbkJJIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwOi8vMS4yNi4yMzYuMTgzOjE4MDA0LyIsInN1YiI6ImhhbG9hZG1pbiIsImlhdCI6MTc2MTEwODc3MywianRpIjoiZTQwNDQ5ZjMtMGI4ZS0xOGE3LWQ0NzUtZWEwZTk3MzlmZTNhIiwicGF0X25hbWUiOiJwYXQtaGFsb2FkbWluLW9QREFXIn0.bU5HcDqLvYyqtvcWl7qKoIGHAqIup2RuM43LW0aY_1frGQLq0OlCvJ6jH3fpBwuTygbeYmjB-uzYnJLgYeERNL4uvl6EAdhRcBkjk9AwNZwp3CILrg8IadsmdbU3mlLpcylHXSUbG7c-Q4rpTJ6nMPyP0AYsH2qk8QwR8p_rgjYOTX8vpyXeNecad0Gl1XlKRWrVOdKg15SuQM3Uy_IFH6-jPBJZihBPjmQlpLgngP35dLUQ6CKWkGw2OsYowg9qHiORXJa9F7OQdUdXOP9SF5_mh507kKItGibfLd8pL3WfTPbIq665sAJ3x43L1n10GXltKT4FS4Qe4L0-kNIuTiKR1hvZ6NY1tvvjc2JRdWrtL8KF9uhCaiyaTrhz4aKRAo5Q-7csTc5LENrcoySn5kdpaOqlLLV-Xk-lV1hxarCoYnp_B2mP0Yvu-lhJzJPmMIqmDCDriGB69wObpTiIVoEo7WpkM5sj6kOrNiuSo653TDG0vtokIWP3FR0eQ1iWK3-Ae_gNTfJgVY7rxkvrLNk0PacXm8gPkNwAA_gNJNlSherIB_QJDFSnxGH4M5EovtDeD4dK0UDJ-xuwV0d_bVMfUzU0colJkXHrvp3b0gxGw0pzitXhoLJIgVbsJisH3MOzYR8QqG4N6zHhiqrEptcxaZMFwTvRB40QkrA4d9o", // 设置认证令牌
    // 'Authorization': 'Basic aGFsb2FkbWluOkNhUmJvbkAyNC4y', // 设置认证令牌
    // 'Authorization': 'Basic c3ViaW5naGU6MTIzNDU2', // 设置认证令牌
    // 'Authorization': 'Basic YWRtaW46Rmd3XzIwMjQh', // 设置认证令牌
    'Content-Type': 'application/json' // 设置内容类型为JSON
  }
};
export default {
  data() {
    return {
      // this.$route.query.activeName,
      // 通知公告
      jsonData: data,
      resultData: {
        ywdt:[],
        wsgs:[],
        zcfg:[],
        listfxfk:[],
        listxts:[],
        listData:[],
      },
      title:this.$route.query.titleName,
      activeName: this.$route.query.titleName,
      activeId: 1,
      tabPosition: "left",
      data1: [
        {itemValue:2 ,itemName:"双碳要闻"},
        {itemValue:4 ,itemName:"政策解读"},
        {itemValue:6 ,itemName:"案例分析"},
        {itemValue:7 ,itemName:"技术共享"},
        {itemValue:9 ,itemName:"平台咨询"},
      ],
      params: {
        pageNum: 1,
        pageSize: 10,
        sortCode1: "",
        sortCode2: "",
      },
      // 总条数
      total: 0,
      tabList: [
        { id: 1, job: "分类系统" },
        { id: 2, job: "查询系统" },
        { id: 3, job: "小贴士" },
      ],
    };
  },

  mounted() {
  
  },

  created() {
    this.getData1();
    this.getData3();
    this.getData6();
    this.getData7()
    this.getData9()

  },
  methods: {
    filesDown(url){
      window.open(url);
    },
         //案例分析
         getDataNew6(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-YLoBe&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          
        }
      });
     
    },
      //技术共享
      getDataNew7(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-OIPiZ&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          
        }
      });
     
    },
      //平台咨询
      getDataNew9(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-ajqMn&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          
        }
      });
     
    },
     //政策解读
    getDataNew3(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-upXaM&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          that.total=response.data.items.length;
          that.resultData.listxts=response.data.items.slice(0,10);
        }
      });
    },
    //双碳要闻
    getDataNew1(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3D76514a40-6ef1-4ed9-b58a-e26945bde3ca&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
        }
      });
    },

    //政策解读
    getData3(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-upXaM&keyword=', config).then(function(response) {
        if(response.data.length!=0){
          if(that.$route.query.titleName=='政策解读'||this.title=='政策解读'){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
            console.log(response.data);
            console.log(response.data);
          }
        }
      })
     
    },
     //双碳要闻
    getData1(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3D76514a40-6ef1-4ed9-b58a-e26945bde3ca&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          if(that.$route.query.titleName=='双碳要闻'||this.title=='双碳要闻'){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          }
        }
      });
     
    },
     //案例分析
     getData6(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-YLoBe&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          if(that.$route.query.titleName=='案例分析'||this.title=='案例分析'){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          }
        }
      });
     
    },
      //技术共享
      getData7(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-OIPiZ&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          if(that.$route.query.titleName=='技术共享'||this.title=='技术共享'){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          }
        }
      });
     
    },
      //平台咨询
      getData9(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-ajqMn&keyword=',
          config ).then(response => {
        if(response.data.items.length!=0){
          if(that.$route.query.titleName=='平台咨询'||this.title=='平台咨询'){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice(0,10);
          }
        }
      });
     
    },
    handleClick(tab, event) {
      this.params= {
        pageNum: 1,
        pageSize: 10,
        sortCode1: "",
        sortCode2: "",
      },
      this.title=tab.label;
      if(tab.label=='双碳要闻'){
        this.getDataNew1();
      }else if(tab.label=='政策解读'){
        this.getDataNew3();
      }else if(tab.label=='案例分析'){
        this.getDataNew6();
      }else if(tab.label=='技术共享'){
        this.getDataNew7();
      }else if(tab.label=='平台咨询'){
        this.getDataNew9();
      }
    
    },
   
    // 分页
    //数据条数发生变化
    handleSizeChange(newSize) {
      let that =this;
      that.params.pageSize = newSize;
      if(that.title=='双碳要闻'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-jiQEW&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((that.params.pageNum-1)*that.params.pageSize,that.params.pageNum*newSize);
          }
        }); 
      }else if(that.title=='政策解读'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-bTVqD&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((that.params.pageNum-1)*that.params.pageSize,that.params.pageNum*newSize);
          }
        });
      
      }else if(that.title=='案例分析'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-fClSm&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((that.params.pageNum-1)*that.params.pageSize,that.params.pageNum*newSize);
          }
        });
      
      }else if(that.title=='技术共享'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-VlLis&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((that.params.pageNum-1)*that.params.pageSize,that.params.pageNum*newSize);
          }
        });
      }else if(that.title=='平台咨询'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-zxFEK&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((that.params.pageNum-1)*that.params.pageSize,that.params.pageNum*newSize);
          }
        });
      
      }
    },
    //翻页触发
    handleCurrentChange(currPage) {
      let that =this;
      that.params.pageNum = currPage;
      if(that.title=='双碳要闻'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-jiQEW&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((currPage-1)*that.params.pageSize,that.params.pageSize*currPage);
          }
        });
       
      }else if(that.title=='减排政策'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-bTVqD&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((currPage-1)*that.params.pageSize,that.params.pageSize*currPage);
          }
        });
      
      }else if(that.title=='案例分析'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-fClSm&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((currPage-1)*that.params.pageSize,that.params.pageSize*currPage);
          }
        });
      
      }else if(that.title=='技术共享'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-VlLis&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((currPage-1)*that.params.pageSize,that.params.pageSize*currPage);
          }
        });
      }else if(that.title=='平台咨询'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts?page=1&size=20&labelSelector=content.halo.run%2Fdeleted%3Dfalse&labelSelector=content.halo.run%2Fpublished%3Dtrue&fieldSelector=spec.categories%3Dcategory-zxFEK&fieldSelector=spec.visible%3DPUBLIC&keyword=',
            config ).then(response => {
          if(response.data.items.length!=0){
            that.total=response.data.items.length;
            that.resultData.listxts=response.data.items.slice((currPage-1)*that.params.pageSize,that.params.pageSize*currPage);
          }
        });
      
      }
     
    },
    wordDetail(index,id,title,contentDate){
      let pathInfo = this.$router.resolve({
        path: '/wordDetail',
        query: {titleName:this.title,activeName:this.activeName,resultIndex:index,contentId:id,contentTitle:title,contentDate:contentDate},
      });
      window.open(pathInfo.href,'_blank')
     
    },
  },

};
</script>
<style lang="less" scoped>
//.Risk {
//  background: #f2f2f2;
//  //width: 1200px;
//  margin: 0 auto;
//  margin-bottom: 40px;
//}
//.container {
//  width: 1200px;
//  height: 100%;
//  display: flex;
//  justify-content: flex-end;
//  margin: 0 auto;
//  margin-top: 20px;
//}
//.box {
//  margin-top: 15px;
//  width: 100%;
//  height: 12px;
//}
///deep/ .el-breadcrumb {
//  font-size: 12px;
//  color: rgba(102, 102, 102, 1);
//  line-height: 12px;
//  float: left;
//}
//.dangqian {
//  float: left;
//}
///deep/.el-breadcrumb__inner {
//  font-weight: 400 !important;
//}
//.red {
//  //color: #dd2126;
//}
//
//.isActive {
//  background: #fce9ea;
//}
//.left {
//  width: 180px;
//  height: 267px;
//  background-color: white;
//}
//.smallBox {
//  width: 180px;
//  height: 52px;
//  font-size: 16px;
//  font-family: PingFangSC-Regular, PingFang SC;
//  font-weight: 400;
//  color: rgba(51, 51, 51, 1);
//  line-height: 52px;
//  text-align: center;
//}
//.top {
//  margin-top: 24px;
//  width: 180px;
//  height: 52px;
//  line-height: 52px;
//  display: flex;
//  justify-content: flex-start;
//  //background-color: #dd2126;
//  font-size: 18px;
//  font-family: PingFangSC-Regular, PingFang SC;
//  font-weight: 400;
//}
//.yi {
//  margin-left: 10px;
//  font-size: 16px;
//  line-height: 50px;
//  color: white;
//}
//.right {
//  margin-left: 20px;
//  width: 1000px;
//  min-height: 712px;
//  background-color: white;
//  padding: 41px 40px;
//  box-sizing: border-box;
//}
//i {
//  margin-left: 10px;
//  width: 18px;
//  height: 18px;
//  color: white;
//}
//.blue {
//  color: #2B78D9;
//}
.topbar {
  width: 100%;
  height: 320px;
  /*background: url(../../assets/image/头部背景.png) no-repeat;*/
  display: flex;
  align-items: flex-end;
  position: relative;
}
.BackgroundPic {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
}
.tableTitle {
  width: 152px;
  line-height: 45px;
  position: absolute;
  color: white;
  height: 50px;
  font-size: 38px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  -webkit-background-clip: text;
  margin-left: 250px;
  margin-bottom: 150px;
}
.buttonSet {
  background: #F5F5F5;
  color: #27b268;
  border-radius:5px;
  width: 71px;
  height: 71px;
  margin-top: 20px;
  border: 2px solid #27b268;
  text-align: center;
  // cursor: pointer;
}
</style>
